export const SearchIcon = ({ className = "" }) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 14L10.992 11.9899M12.99 8C12.99 10.7614 10.7536 13 7.99498 13C5.23633 13 3 10.7614 3 8C3 5.23858 5.23633 3 7.99498 3C10.7536 3 12.99 5.23858 12.99 8Z"
        stroke="#2B3674"
        stroke-width="1.4"
        stroke-linecap="round"
      />
    </svg>
  );
};
